import React, { Component } from "react"
import { Row, Col, Card, CardBody, CardTitle, CardText, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, CustomInput } from "reactstrap"
import { withTranslation } from 'react-i18next'
import i18n from 'i18next'
import { Link } from 'react-router-dom'
import update from "immutability-helper"
import Cookies from 'universal-cookie'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { FaQuestionCircle } from 'react-icons/fa'

import cookieImg from "../images/cgv/cookie.png"
import cookieWhiteImg from "../images/cgv/cookie-white.webp"

class CookieConsent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      strictlyNecessaryDisplay: false,
      performanceDisplay: false,
      targettingDisplay: false,
    }

    this.acceptAllCookies = this.acceptAllCookies.bind(this)
    this.displayCookieModal = this.displayCookieModal.bind(this)
    this.toogleCookieInfo = this.toogleCookieInfo.bind(this)
    this.cancel = this.cancel.bind(this)
    this.savePref = this.savePref.bind(this)
    this.toogleCookiePref = this.toogleCookiePref.bind(this)
  }

  acceptAllCookies() {
    // Hide cookie banner and modal, and allow all cookies
    this.props.setStateRoot({
      cookies: {
        displayCookieBanner: false,
        displayCookieModal: false,
        necessary: true,
        performance: true,
        targetting: true
      }
    }, (() => {
      this.storeCookiePref(true, true, true)
    }))
  }

  storeCookiePref(necessary, performance, targetting) {
    if (!this.props.debug) {
      const cookies = new Cookies()
      cookies.set("cookie-consent", {
        necessary: necessary,
        performance: performance,
        targetting: targetting,
      }, {"path": "/"})
    }
    // Enable GA if performance is set to true
    if (performance) {
      this.props.enableGoogleAnalytics()
    } else {
      this.props.removeCookies(true, false)
    }

    // Enable FB and Sendinblue and Hubspot if targetting is true
    if (targetting) {
      this.props.enableTracking(["facebook", "sendinblue", "hubspot"])
    } else {
      this.props.removeCookies(false, true)
    }
  }

  displayCookieModal() {
    this.props.setStateRoot({
      cookies: {
        displayCookieBanner: false,
        displayCookieModal: true,
        necessary: true,
        performance: false,
        targetting: false
      }
    })
  }

  cancel() {
    // Hide modal and display banner
    this.setState({
      strictlyNecessaryDisplay: false,
      performanceDisplay: false,
      targettingDisplay: false,
    }, () => {
      this.props.setStateRoot({
        cookies: {
          displayCookieBanner: true,
          displayCookieModal: false,
          necessary: true,
          performance: false,
          targetting: false
        }
      })
    })
  }

  toogleCookiePref(event) {
    this.props.setStateRoot({
      cookies: update(this.props.cookies, {
        [event.target.id]: {$set: !this.props.cookies[event.target.id]}
      })
    })
  }

  savePref() {
    // Hide cookie banner and modal, and allow all cookies
    this.props.setStateRoot({
      cookies: {
        displayCookieBanner: false,
        displayCookieModal: false,
        necessary: true,
        performance: this.props.cookies.performance,
        targetting: this.props.cookies.targetting
      }
    }, (() => {
      this.storeCookiePref(true, this.props.cookies.performance, this.props.cookies.targetting)
    }))
  }

  toogleCookieInfo(event) {
    this.setState({
      [event.target.id]: !event.target.value,
    })
  }

  render() {
    const t = this.props.t
    const language = i18n.language ? ( i18n.language.startsWith("fr") ? "fr" : i18n.language.startsWith("en") ? "en" : 'es' ) : undefined
    const langSubPath = language === "en" ? "/en" : language === "es" ? "/es" : ""

    if (this.props.cookies.displayCookieBanner) {
      return(
        <Card className="cookie-card">
          <CardBody>
            <CardTitle className="cookie-title" tag="h5">
              <LazyLoadImage className="" alt={t("cookie-consent|cookie")} src={cookieImg} width='5%' style={{transform: 'translateX(-20px)'}} />
                {t("cookie-consent|Nos cookies sont bons pour le microbiote")}
              </CardTitle>
            <CardText>{t("cookie-consent|Nous utilisons des cookies pour vous offrir une meilleure expérience de navigation. En cliquant sur \"Accepter\", vous nous autorisez à déposer des cookies conformément à notre")} <Link className="light-blue" to={langSubPath + "/" + t("path|politique-cookie") + "/"}>{t("politique cookies")}</Link>.</CardText>
            <Row className="flex-column-reverse flex-lg-row">
              <Col md="6"  className="my-1 px-1"><Button onClick={this.displayCookieModal} size="sm" color="secondary" className="" block>{t("cookie-consent|Paramétrer")}</Button></Col>
              <Col md="6"  className="my-1 px-1"><Button onClick={this.acceptAllCookies} size="sm" className="" color="primary" block>{t("cookie-consent|Accepter")}</Button></Col>
            </Row>
          </CardBody>
        </Card>
      )
    } else if (this.props.cookies.displayCookieModal) {
      return (
        <div>
          <Modal isOpen={true} className="">
            <ModalHeader className="cookie-title">{t("cookie-consent|Réglages des cookies")}</ModalHeader>
            <ModalBody className="cookie-modal">
              <span>{t("cookie-consent|Lorsque vous visitez notre site web, il peut stocker ou récupérer des informations sur votre navigateur, principalement sous la forme de cookies.")}</span>{" "}
              <span>{t("cookie-consent|Ces informations peuvent porter sur vous, vos préférences ou votre appareil et sont principalement utilisées pour que le site fonctionne comme vous l'attendez.")}</span>{" "}
              <span>{t("cookie-consent|En général, ces informations ne permettent pas de vous identifier directement, mais elles peuvent vous offrir une expérience web plus personnalisée.")}</span>{" "}
              <span>{t("cookie-consent|Parce que nous respectons votre droit à la vie privée, vous pouvez choisir de ne pas autoriser certains types de cookies.")}</span>{" "}
              <span>{t("cookie-consent|Veuillez noter que le blocage de certains types de cookies peut avoir un impact sur votre expérience du site et sur les services que nous sommes en mesure de vous offrir.")}</span>
              <FormGroup>
                <div>
                <Row className="mt-2">
                  <Col xs="9"><h6 value={this.state.strictlyNecessaryDisplay} id="strictlyNecessaryDisplay" onClick={this.toogleCookieInfo} className="card-clickable cookie-title">{t("cookie-consent|Cookies nécessaires")} <FaQuestionCircle size={12} /></h6></Col>
                  <Col xs="3"><CustomInput className="cookie-input" checked={true} type="switch" id="strictlyNecessary" disabled /></Col>
                </Row>
                {this.state.strictlyNecessaryDisplay ? <p className="cookie-title">{t("cookie-consent|Ces cookies sont nécessaires au bon fonctionnement de notre site web et ne peuvent pas être désactivés dans nos systèmes. Ils ne sont généralement définis qu'en réponse à des actions effectuées par vous qui équivalent à une demande de services, comme le réglage de vos préférences en matière de confidentialité, la connexion ou le remplissage de formulaires, ou lorsqu'ils sont essentiels pour vous fournir un service que vous avez demandé. Vous ne pouvez pas refuser ces cookies. Vous pouvez configurer votre navigateur pour qu'il bloque ces cookies ou vous alerte à leur sujet, mais si vous le faites, certaines parties du site ne fonctionneront alors pas. Ces cookies ne stockent pas d'informations permettant de vous identifier personnellement.")}</p> : null}
                <Row className="mt-2">
                  <Col xs="9"><h6 value={this.state.performanceDisplay} id="performanceDisplay" onClick={this.toogleCookieInfo} className="card-clickable cookie-title">{t("cookie-consent|Cookies de performances")} <FaQuestionCircle size={12} /></h6></Col>
                  <Col xs="3"><CustomInput className="cookie-input" id="performance" onChange={this.toogleCookiePref} checked={this.props.cookies.performance} type="switch" /></Col>
                </Row>
                {this.state.performanceDisplay ? <p className="cookie-title">{t("cookie-consent|Ces cookies nous permettent de compter les visites et les sources de trafic afin de pouvoir mesurer et améliorer les performances de notre site. Ils nous aident à savoir quelles sont les pages les plus et les moins populaires et à voir comment les visiteurs se déplacent sur le site, ce qui nous aide à optimiser votre expérience. Toutes les informations que ces cookies collectent sont agrégées et donc anonymes. Si vous n'autorisez pas ces cookies, nous ne serons pas en mesure d'utiliser vos données de cette manière.")}</p> : null}
                <Row className="mt-2">
                  <Col xs="9"><h6 value={this.state.targettingDisplay} id="targettingDisplay" onClick={this.toogleCookieInfo} className="card-clickable cookie-title">{t("cookie-consent|Cookies marketing")} <FaQuestionCircle size={12} /></h6></Col>
                  <Col xs="3"><CustomInput className="cookie-input" id="targetting" onChange={this.toogleCookiePref} checked={this.props.cookies.targetting} type="switch" /></Col>
                </Row>
                {this.state.targettingDisplay ? <p className="cookie-title">{t("cookie-consent|Ces cookies peuvent être placés sur notre site par nos partenaires publicitaires. Ils peuvent être utilisés par ces sociétés pour établir un profil de vos intérêts et vous montrer des publicités pertinentes sur d'autres sites. Ils ne stockent pas directement des informations personnelles mais sont basés sur l'identification unique de votre navigateur et de votre appareil Internet. Si vous n'autorisez pas ces cookies, vous verrez des publicités moins ciblées.")}</p> : null}
                </div>
              </FormGroup>
            </ModalBody>
            <ModalFooter className="cookie-footer">
              <Button onClick={this.savePref} className="cookie-btn" size="xs" color="primary">{t("cookie-consent|Enregistrer")}</Button>
              <Button onClick={this.acceptAllCookies} className="cookie-btn" size="xs" color="secondary">{t("cookie-consent|Accepter tous les cookies")}</Button>
              <Button onClick={this.cancel} size="xs" color="link">{t("cookie-consent|Annuler")}</Button>
            </ModalFooter>
          </Modal>
        </div>
      )
    } else {
      return (
        <div className="cookie-consent-small-btn">
          <LazyLoadImage onClick={this.displayCookieModal} className="" alt={t("cookie-consent|cookie")} height={193} width={200} src={cookieWhiteImg} style={{width:'10%', height:'auto'}} />
        </div>
      )
    }

  }
}

export default withTranslation()(CookieConsent)
